import { render, staticRenderFns } from "./QuestionModule.vue?vue&type=template&id=5418620d&scoped=true&"
import script from "./QuestionModule.vue?vue&type=script&lang=js&"
export * from "./QuestionModule.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModule.vue?vue&type=style&index=0&id=5418620d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418620d",
  null
  
)

export default component.exports